import { useMemo } from 'react'

import { Text } from '@hhgtech/hhg-components/adapters'
import { Avatar } from '@hhgtech/hhg-components/mantine'
import { theme } from '@hhgtech/hhg-components/misc'

import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { assetImagePath } from 'interfaces/constants'
import { ExpertUserSummary } from 'interfaces/types'

import { StyledExpertCard } from './index.styled'
type ExpertCardProps = {
  expert: ExpertUserSummary
}

export const ExpertCard = ({ expert }: ExpertCardProps) => {
  const isMobile = useIsMobile()
  const { locale } = useRouterExtend()
  const { avatar, badge } = useMemo(() => {
    if ('undefined' !== typeof expert) {
      const { role } = expert

      return {
        avatar:
          expert?.avatarLarge || expert?.avatar || expert?.avatarThumbnail,
        badge: role,
      }
    }
    return {
      avatar: `${assetImagePath}/hhg-logo.png`,
      badge: '',
    }
  }, [expert])

  return (
    <StyledExpertCard data-locale={locale}>
      <div className="expert-avatar" data-role={badge}>
        <Avatar
          size={isMobile ? 'lg' : 'xl'}
          src={avatar}
          withIndicator={!!badge}
          indicatorConfig={
            badge
              ? {
                  size: isMobile ? 18 : 25,
                  label: (
                    <img
                      src={`${assetImagePath}/article-${badge}.svg`}
                      alt={`expert badge ${badge}`}
                      loading="lazy"
                      width={isMobile ? 18 : 25}
                      height={isMobile ? 18 : 25}
                    />
                  ),
                }
              : undefined
          }
        />
      </div>
      <div className="expert-description">
        <a {...(expert.profileUrl && { href: expert.profileUrl })}>
          <Text size="s3" type="semiBold">
            {expert.displayName}
          </Text>
        </a>
        {(expert.specialty || expert.organisation) && (
          <Text size="p3" color={theme.colors.gray600}>
            <Text as="span" size="p3">
              {expert.specialty}
            </Text>
            {expert.organisation && (
              <a
                {...(expert.organisationUrl && {
                  href: expert.organisationUrl,
                })}
              >
                <Text as="span" size="p3">
                  {` • ${expert.organisation}`}
                </Text>
              </a>
            )}
          </Text>
        )}
      </div>
    </StyledExpertCard>
  )
}
